module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAIVBMVEUAAAD////////////////////////////////////////PIev5AAAACnRSTlMAgN8g78+PEK9QYspnmQAAAKJJREFUOMvNkjEOwiAYhTEOrsyOjoxMPYCTu3tnL+AdnLwCRk36TtlHSxt4ZSZ9yRv+fPlIgN/sPoeLrYMzQh04fOoAQCPwLK9wfyfQoc/BA2EGR1dc5gTATsADPwEhAgoFMK+osJ4dcuCjwjrW5oBHpOhD+hVQEEUEVSioIoIoFLZKLqhidTuS8l/mcju6a7/Muh0yA9CfbAgkTcENmq/ZaUYdub4a+kAMfQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./images/baseintrov2/btn-ico.png
// module id = 594
// module chunks = 0